import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CheckroomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"checkroom"}/>
}
